<div style="width: 100vw;">
  <nav
    id="navbar"
    class="navbar full-width navbar-expand-lg navbar-light bg-light"
  >
    <div class="nav-bar-container">
      <!--dropdownbutton-->
      <div class="dropdown">
        <button
          class="navbar-toggler dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <p class="closeDropdown">X</p>
          <div class="logos">
            <img
              *ngIf="!this.usuario"
              class="img-header-dropdown"
              src="../../../../assets/images/logo-positivo-kaleido.png"
              (click)="goToHome()"
            />
            <img
              *ngIf="this.usuario"
              class="img-header-dropdown"
              src="../../../../assets/images/logo-positivo-kaleido.png"
              (click)="goToInitM()"
            />
            <!-- <img
              (click)="goTo('https://infodeclat.com/')"
              class="img-infodec"
              src="../../../../assets/images/logo-infodec-png.png"
              alt=""
            /> -->
          </div>

          <a
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="!this.usuario"
            (click)="goToSoluction()"
            [href]="rutaSoluction"
          >
            Solución
          </a>
          <a
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="!this.usuario"
            (click)="goToWorlds()"
            [href]="rutaWorlds"
          >
            Mundos
          </a>
          <a
            (click)="goToPlans('plans')"
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="!this.usuario"
          >
            Planes
          </a>

          <a
            (click)="getOptionSeleted('contact')"
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="!this.usuario"
          >
            Contacto
          </a>
          <a
            (click)="logout()"
            *ngIf="this.usuario"
            class="nav-anchor-li dropdown-item dropdown-a"
          >
            Cerrar sesión
          </a>
          <a
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="this.usuario"
            (click)="goToM('auth/soluction')"
            [href]="rutaSoluctionM"
          >
            Solución
          </a>
          <a
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="this.usuario"
            (click)="goToWorldsM()"
            [href]="rutaWorldsM"
          >
            Mundos
          </a>
          <a
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="this.usuario"
            (click)="getOptionSeletedM('auth/plans')"
          >
            Planes
          </a>

          <!-- <a
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="this.usuario && this.usuario.es_empresa == 'Si'"
            (click)="getOptionSeletedM('auth/events')"
          >
            Mis eventos
          </a> -->

          <a
            (click)="getOptionSeletedM('auth/news')"
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="this.usuario"
          >
            Noticias
          </a>
          <a
            (click)="getOptionSeletedM('auth/home')"
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="this.usuario"
          >
            Mis eventos
          </a>
          <a
            (click)="getOptionSeletedM('auth/account')"
            class="nav-anchor-li dropdown-item dropdown-a"
            *ngIf="this.usuario"
          >
            Mi cuenta
          </a>

          <div class="btn-login-container" *ngIf="!this.usuario">
            <button (click)="openLoginModal('login')" class="btn btn-login">
              INICIAR SESIÓN
            </button>
          </div>
          <div class="btn-danger-container" *ngIf="!this.usuario">
            <button (click)="openLoginModal('register')" class="btn btn-danger">
              REGISTRARSE
            </button>
          </div>
          <div class="btn-danger-container2" *ngIf="!this.usuario">
            <button class="btn btn-danger2" (click)="goToPlans()">
              COMPRAR PLAN
            </button>
          </div>
          <div class="btn-danger-container" *ngIf="loginFromDemo == 'true' && this.usuario">
            <button class="btn btn-danger" (click)="goToPlans()">
              COMPRAR PLAN
            </button>
          </div>
        </div>
      </div>
      <!--drop end-->

      <!-- Escritorio -->
      <div class="container-fluid nav-header-container">
        <!-- start logo -->
        <div class="col-auto pl-0">
          <img
            *ngIf="!this.usuario"
            class="img-header"
            src="../../../../assets/images/logo-positivo-kaleido.png"
            alt=""
            (click)="goToHome()"
          />
          <img
            *ngIf="this.usuario"
            class="img-header"
            src="../../../../assets/images/logo-positivo-kaleido.png"
            alt=""
            (click)="goToInitM()"
          />
          <!-- <img
            (click)="goTo('https://infodeclat.com/')"
            width="160px"
            class="img-infodec"
            src="../../../../assets/images/logo-infodec-png.png"
            alt=""
          /> -->
        </div>
        <!-- end logo -->

        <div class="navbar-collapse collapse justify-content-start">
          <ul
            id="accordion"
            class="nav navbar-nav margin-auto alt-font text-normal"
            data-in="fadeIn"
            data-out="fadeOut"
          >
            <!-- Usuario deslogueado -->
            <li *ngIf="!this.usuario" class="nav-item">
              <a
                class="nav-anchor-li"
                [ngClass]="{
                  'active-nav-item': activeOption == 'soluction'
                }"
                (click)="goToSoluction()"
                [href]="rutaSoluction"
              >
                Solución
              </a>
              <div
                [ngClass]="{ 'line-option': activeOption == 'soluction' }"
              ></div>
            </li>
            <li *ngIf="!this.usuario" class="nav-item">
              <a
                class="nav-anchor-li"
                [ngClass]="{
                  'active-nav-item': activeOption == 'worlds'
                }"
                (click)="goToWorlds()"
                [href]="rutaWorlds"
              >
                Mundos
              </a>
              <div
                [ngClass]="{ 'line-option': activeOption == 'worlds' }"
              ></div>
            </li>
            <li *ngIf="!this.usuario" class="nav-item">
              <a
                (click)="getOptionSeleted('plans')"
                class="nav-anchor-li"
                [ngClass]="{ 'active-nav-item': activeOption == 'plans' }"
              >
                Planes
              </a>
              <div [ngClass]="{ 'line-option': activeOption == 'plans' }"></div>
            </li>

            <li *ngIf="!this.usuario" class="nav-item">
              <a
                (click)="getOptionSeleted('contact')"
                class="nav-anchor-li"
                [ngClass]="{
                  'active-nav-item': activeOption == 'contact'
                }"
              >
                Contacto
              </a>
              <div
                [ngClass]="{ 'line-option': activeOption == 'contact' }"
              ></div>
            </li>

            <!-- Usuario logueado -->
            <li *ngIf="this.usuario" class="nav-item">
              <a
                class="nav-anchor-li"
                [ngClass]="{
                  'active-nav-item': activeOptionM == 'soluction'
                }"
                (click)="goToM('auth/soluction')"
                [href]="rutaSoluctionM"
              >
                Solución
              </a>
              <div
                [ngClass]="{ 'line-option': activeOptionM == 'soluction' }"
              ></div>
            </li>
            <li *ngIf="this.usuario" class="nav-item">
              <a
                class="nav-anchor-li"
                [ngClass]="{
                  'active-nav-item': activeOptionM == 'worlds'
                }"
                (click)="goToWorldsM()"
                [href]="rutaWorldsM"
              >
                Mundos
              </a>
              <div
                [ngClass]="{ 'line-option': activeOptionM == 'worlds' }"
              ></div>
            </li>
            <li *ngIf="this.usuario" class="nav-item">
              <a
                (click)="goToM('auth/plans')"
                class="nav-anchor-li"
                [ngClass]="{ 'active-nav-item': activeOptionM == 'plans' }"
              >
                Planes
              </a>
              <div
                [ngClass]="{ 'line-option': activeOptionM == 'plans' }"
              ></div>
            </li>

            <li *ngIf="this.usuario" class="nav-item">
              <a
                (click)="goToM('auth/news')"
                class="nav-anchor-li"
                [ngClass]="{
                  'active-nav-item': activeOptionM == 'news'
                }"
              >
                Noticias
              </a>
              <div
                [ngClass]="{ 'line-option': activeOptionM == 'news' }"
              ></div>
            </li>

            <li *ngIf="this.usuario" class="nav-item">
              <a
                (click)="goToM('auth/contact')"
                class="nav-anchor-li"
                [ngClass]="{
                  'active-nav-item': activeOptionM == 'contact'
                }"
              >
                Contacto
              </a>
              <div
                [ngClass]="{ 'line-option': activeOptionM == 'contact' }"
              ></div>
            </li>
          </ul>
        </div>

        <div class="navbar-collapse collapse justify-content-end">
          <button
            (click)="logout()"
            *ngIf="this.usuario"
            type="button"
            class="btn btn-outline-danger app-light-blue-button auth-button logout"
          >
            Cerrar sesión
          </button>

          <button
            *ngIf="!this.usuario"
            type="button"
            class="btn btn-outline-danger app-light-blue-button auth-button login"
            (click)="openLoginModal('login')"
          >
            Iniciar sesión
          </button>

          <button
            *ngIf="!this.usuario"
            type="button"
            class="btn btn-outline-danger app-light-blue-button auth-button register"
            (click)="openLoginModal('register')"
          >
            Registrarse
          </button>

          <button
            *ngIf="!this.usuario"
            type="button"
            class="btn btn-danger app-light-blue-button auth-button logout"
            (click)="goToPlans()"
          >
            Comprar plan
          </button>

          <button
            *ngIf="this.usuario"
            type="button"
            class="btn btn-danger app-light-blue-button auth-button logout"
            (click)="goToPlansM()"
          >
            Comprar plan
          </button>

          <!-- <li
            *ngIf="this.usuario && this.usuario.es_empresa == 'Si'"
            class="nav-item"
            (click)="getOptionSeletedM('auth/events')"
            style="margin-left: 30px;"
          >
            <a
              class="nav-anchor-li"
              [ngClass]="{ 'active-nav-item': activeOptionM == 'events' }"
            >
              Mis eventos
            </a>
            <div [ngClass]="{ 'line-option': activeOptionM == 'events' }"></div>
          </li> -->

          <li
          *ngIf="this.usuario"
          class="nav-item"
          (click)="getOptionSeletedM('auth/home')"
          style="margin-left: 30px;"
        >
          <a
            class="nav-anchor-li"
            [ngClass]="{ 'active-nav-item': activeOptionM == 'events' }"
          >
            Mis eventos
          </a>
          <div [ngClass]="{ 'line-option': activeOptionM == 'events' }"></div>
        </li>
        
          <li
            *ngIf="this.usuario"
            class="nav-item"
            (click)="getOptionSeletedM('auth/account')"
          >
            <a
              class="nav-anchor-li"
              [ngClass]="{
                'active-nav-item': activeOptionM == 'account'
              }"
            >
              Mi cuenta
            </a>
            <div
              [ngClass]="{ 'line-option': activeOptionM == 'account' }"
            ></div>
          </li>
        </div>
      </div>
      <!-- Fin Escritorio -->
    </div>
  </nav>
</div>
